export const checkCardNumber = (value: string): boolean => {
  // remove spaces, 0000 0000 -> 00000000
  const cardNumber = value.replace(/\s/g, '');

  let sum = 0;
  const digits = cardNumber.length;
  const parity = digits % 2;

  for (let i = 0; i < digits; i++) {
    let digit = parseInt(cardNumber.charAt(i));
    if (i % 2 === parity) {
      digit *= 2;
      if (digit > 9) {
        digit -= 9;
      }
    }
    sum += digit;
  }

  return sum % 10 === 0;
};
